import { render, staticRenderFns } from "./CompanyContact.vue?vue&type=template&id=6750811b"
import script from "./CompanyContact.vue?vue&type=script&lang=js"
export * from "./CompanyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports